/* WESN BOK survey (sections/bok-survey.liquid).
   One question per screen. Answers stay in sessionStorage until the email step, then go to Klaviyo:
   an event (one per submission) and profile properties (one per question), plus the list subscription.
   Klaviyo client API: https://developers.klaviyo.com/en/reference/create_client_event */
(function () {
  'use strict';

  var REVISION = '2026-07-15';
  var STORE = 'wesn-bok-survey-v1';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function pad(n) { return ('0' + n).slice(-2); }

  function newId() {
    try {
      var b = new Uint8Array(16);
      window.crypto.getRandomValues(b);
      return Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    } catch (e) {
      return String(Date.now()) + String(Math.random()).slice(2);
    }
  }

  function init(root) {
    if (!root || root.bokSurveyBound) return;
    root.bokSurveyBound = true;

    var d = root.dataset;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var form = root.querySelector('[data-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var questions = steps.filter(function (s) { return s.dataset.step === 'question'; });
    var barLabel = root.querySelector('[data-bar-label]');
    var barCount = root.querySelector('[data-bar-count]');
    var emailEl = root.querySelector('[data-email]');
    var submitBtn = root.querySelector('[data-submit]');
    var submitLabel = root.querySelector('[data-submit-label]');
    var submitText = submitLabel ? submitLabel.textContent : '';
    var current = 0;
    var uid = newId();
    var sending = false;
    var ready = false; /* the stored draft is read before anything is written back */
    if (!form || !steps.length) return;

    /* ----- reading and showing answers ----- */
    function read(step) {
      var key = step.dataset.key || '';
      if (step.dataset.kind === 'text') {
        var area = step.querySelector('[data-answer]');
        return { key: key, value: area ? area.value.trim() : '', needsDetail: false, detail: '' };
      }
      var sel = step.querySelector('input[type="radio"]:checked');
      var det = step.querySelector('[data-detail] input');
      var needs = !!(sel && sel.hasAttribute('data-detail-label'));
      return { key: key, value: sel ? sel.value : '', needsDetail: needs, detail: needs && det ? det.value.trim() : '' };
    }

    function sync(step) {
      var sel = step.querySelector('input[type="radio"]:checked');
      Array.prototype.forEach.call(step.querySelectorAll('.bok-survey__opt'), function (label) {
        label.classList.toggle('is-selected', !!sel && label.contains(sel));
      });
      var box = step.querySelector('[data-detail]');
      if (box) {
        var on = !!(sel && sel.hasAttribute('data-detail-label'));
        box.hidden = !on;
        if (on) {
          box.querySelector('[data-detail-label]').textContent = sel.getAttribute('data-detail-label') || '';
          box.querySelector('input').setAttribute('placeholder', sel.getAttribute('data-detail-placeholder') || '');
        }
      }
      var area = step.querySelector('[data-answer]');
      var count = step.querySelector('[data-count]');
      if (area && count) count.textContent = String(area.value.length);
    }

    function check(step) {
      if (step.dataset.step !== 'question') return '';
      var a = read(step);
      var required = step.hasAttribute('data-required');
      if (step.dataset.kind === 'text') return required && !a.value ? (d.msgText || '') : '';
      if (!a.value) return required ? (d.msgChoose || '') : '';
      if (a.needsDetail && !a.detail) return d.msgDetail || '';
      return '';
    }

    function setError(step, msg) {
      var el = step.querySelector('[data-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    /* ----- moving between screens ----- */
    function show(i, byUser) {
      current = Math.max(0, Math.min(i, steps.length - 1));
      var step = steps[current];
      var kind = step.dataset.step;
      var qi = questions.indexOf(step);
      steps.forEach(function (s, n) { s.hidden = n !== current; });
      root.setAttribute('data-at', kind);
      if (barLabel) barLabel.textContent = step.dataset.label || '';
      if (barCount) {
        barCount.textContent = kind === 'intro' ? (d.countIntro || '')
          : kind === 'question' ? pad(qi + 1) + ' / ' + pad(questions.length)
          : kind === 'email' ? (d.countEmail || '') : '';
      }
      var done = kind === 'intro' ? 0 : kind === 'question' ? qi / Math.max(questions.length, 1) : 1;
      root.style.setProperty('--bos-progress', Math.round(done * 100) + '%');
      if (byUser) {
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
        var head = step.querySelector('[tabindex="-1"]');
        if (head) { try { head.focus({ preventScroll: true }); } catch (e) { head.focus(); } }
      }
      save();
    }

    function next() {
      var step = steps[current];
      var msg = check(step);
      setError(step, msg);
      if (msg) return;
      show(current + 1, true);
    }

    /* ----- draft in sessionStorage (answers only, never the email) ----- */
    function save() {
      if (design || !ready) return;
      try {
        if (steps[current].dataset.step === 'done') { window.sessionStorage.removeItem(STORE); return; }
        var draft = { step: current, uid: uid, a: [] };
        questions.forEach(function (q) { var r = read(q); draft.a.push({ v: r.value, d: r.detail }); });
        window.sessionStorage.setItem(STORE, JSON.stringify(draft));
      } catch (e) {}
    }

    function restore() {
      if (design) return;
      var draft = null;
      try { draft = JSON.parse(window.sessionStorage.getItem(STORE) || 'null'); } catch (e) {}
      if (!draft || !Array.isArray(draft.a) || draft.a.length !== questions.length) return;
      if (typeof draft.uid === 'string' && draft.uid) uid = draft.uid;
      questions.forEach(function (q, n) {
        var a = draft.a[n] || {};
        if (q.dataset.kind === 'text') {
          var area = q.querySelector('[data-answer]');
          if (area && typeof a.v === 'string') area.value = a.v.slice(0, 2000);
        } else if (typeof a.v === 'string' && a.v) {
          Array.prototype.forEach.call(q.querySelectorAll('input[type="radio"]'), function (r) { r.checked = r.value === a.v; });
          var det = q.querySelector('[data-detail] input');
          if (det && typeof a.d === 'string') det.value = a.d.slice(0, 500);
        }
        sync(q);
      });
      var at = parseInt(draft.step, 10);
      if (at > 0 && at < steps.length && steps[at].dataset.step !== 'done') show(at, false);
    }

    /* ----- sending to Klaviyo ----- */
    function publicKey() {
      if (d.klaviyoKey) return d.klaviyoKey;
      var tag = document.querySelector('script[src*="klaviyo.js?company_id="],script[src*="klaviyo.com/onsite/js"]');
      var m = tag && /company_id=([A-Za-z0-9]+)/.exec(tag.src);
      return m ? m[1] : '';
    }

    function post(path, key, body) {
      return window.fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + path + ' ' + res.status);
        return res;
      });
    }

    function setSending(on) {
      sending = on;
      if (submitBtn) submitBtn.disabled = on;
      if (submitLabel) submitLabel.textContent = on ? (d.labelSending || submitText) : submitText;
    }

    function finish() {
      setSending(false);
      var doneAt = -1;
      steps.forEach(function (s, n) { if (s.dataset.step === 'done') doneAt = n; });
      if (doneAt > -1) show(doneAt, true);
      uid = newId();
    }

    function send() {
      if (sending) return;
      var step = steps[current];
      for (var n = 0; n < questions.length; n++) {
        var msg = check(questions[n]);
        if (msg) { show(steps.indexOf(questions[n]), true); setError(questions[n], msg); return; }
      }
      var email = emailEl ? emailEl.value.trim() : '';
      if (!EMAIL_RE.test(email) || email.length > 254) {
        setError(step, d.msgEmail || '');
        if (emailEl) { emailEl.setAttribute('aria-invalid', 'true'); emailEl.focus(); }
        return;
      }
      if (emailEl) emailEl.removeAttribute('aria-invalid');
      setError(step, '');

      var trap = root.querySelector('[data-hp]');
      if (trap && trap.value) { finish(); return; }

      var key = publicKey();
      if (!key || !window.fetch) { setError(step, d.msgNetwork || ''); return; }

      var prefix = d.prefix ? d.prefix + ': ' : '';
      var eventProps = { Survey: d.source || 'BOK survey', Page: window.location.pathname };
      var profileProps = {};
      questions.forEach(function (q) {
        var r = read(q);
        if (!r.key || !r.value) return;
        eventProps[r.key] = r.value;
        profileProps[prefix + r.key] = r.value;
        if (r.needsDetail && r.detail) {
          eventProps[r.key + ' (other)'] = r.detail;
          profileProps[prefix + r.key + ' (other)'] = r.detail;
        }
      });
      profileProps[prefix + 'Submitted on'] = new Date().toISOString().slice(0, 10);

      var calls = [post('events', key, {
        data: {
          type: 'event',
          attributes: {
            properties: eventProps,
            unique_id: uid,
            metric: { data: { type: 'metric', attributes: { name: d.event || 'BOK Survey Completed' } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } }
          }
        }
      })];
      if (d.klaviyoList) {
        calls.push(post('subscriptions', key, {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: d.source || 'BOK survey',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: profileProps,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: d.klaviyoList } } }
          }
        }));
      }

      setSending(true);
      Promise.all(calls).then(function () {
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e) {}
        finish();
      }).catch(function () {
        setSending(false);
        setError(step, d.msgNetwork || '');
      });
    }

    /* ----- events ----- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-next],[data-back]') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-next')) next();
      else show(current - 1, true);
    });
    root.addEventListener('change', function (e) {
      var step = e.target.closest ? e.target.closest('[data-step]') : null;
      if (!step) return;
      sync(step);
      setError(step, '');
      save();
    });
    root.addEventListener('input', function (e) {
      var step = e.target.closest ? e.target.closest('[data-step]') : null;
      if (!step) return;
      if (e.target.hasAttribute('data-answer')) sync(step);
      setError(step, '');
      if (e.target !== emailEl) save();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (steps[current].dataset.step === 'email') send();
      else if (steps[current].dataset.step !== 'done') next();
    });
    if (design) {
      root.addEventListener('shopify:block:select', function (e) {
        var step = e.target.closest ? e.target.closest('[data-step]') : null;
        if (step) show(steps.indexOf(step), false);
      });
    }

    /* answer photos sit in hidden screens: fetch them now so they are there when the screen opens */
    Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    questions.forEach(sync);
    show(0, false);
    restore();
    ready = true;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bok-survey]'), init);
  }
  boot();
  if (!window.bokSurveyGlobal) {
    window.bokSurveyGlobal = true;
    document.addEventListener('shopify:section:load', boot);
  }
})();
